import { Divider } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { AiCropSize } from '../components/ai-crop-size/AiCropSize';
import { Header } from '../components/ai-crop-size/Header';
import { HideNotice } from '../components/ai-crop-size/HideNotice';
import { SizeControl } from '../components/ai-crop-size/SizeControl';
import { useAiCropSizeService } from '../services/useAiCropSizeService';

interface AiCropSizeContainerProps {
  hasModelInfo?: boolean;
}

export const AiCropSizeContainer = ({ hasModelInfo = false }: AiCropSizeContainerProps) => {
  const {
    hideAiCropSizeInfo,
    aiCropSizeImageList,
    isEditRequested,
    handleZoom,
    handleEditRequest,
    aiImageRef,
    requestEditButtonRef,
  } = useAiCropSizeService();

  if (hideAiCropSizeInfo) {
    return <HideNotice />;
  }

  return (
    <Container hasModelInfo={hasModelInfo}>
      <Header />
      <AiCropSize imageList={aiCropSizeImageList} setAiImageRef={aiImageRef} />
      <SizeControl
        isEditRequested={isEditRequested}
        onClickZoom={handleZoom}
        onEditRequest={handleEditRequest}
        setRequestEditButtonRef={requestEditButtonRef}
      />
    </Container>
  );
};

const Container = styled.div<{ hasModelInfo: boolean }>`
  padding-bottom: ${({ hasModelInfo }) => (hasModelInfo ? '24px' : '240px')};
  background-color: ${vars.color.staticWhite};
`;
